import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Group } from '@edl-development/edl-common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { A48_STATUS_FILTERS } from 'src/app/constants/roster.constants';
import { AdvancedRosterSearch } from '../../model/advanced-roster-search.model';

@Component({
    selector: 'edl-modal-advanced-roster-search',
    styleUrls: ['edl-modal-advanced-roster-search.component.scss'],
    templateUrl: './edl-modal-advanced-roster-search.component.html'
})
export class EdlModalAdvancedRosterSearch implements OnInit {
    @Input() initialSearch: AdvancedRosterSearch;
    @Input() Statuses: Readonly<{ value: number, label: string, disabled: boolean }[]>;
    @Input() Approvers: Readonly<{ UserID: string, DisplayName: string }[]>;
    @Input() isAct48Enabled: boolean;
    @Input() Groups: Readonly<Group[]>;

    public form: UntypedFormGroup;
    public selectedGroupsCount: number;

    A48_STATUS_FILTERS = A48_STATUS_FILTERS;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder
    ) {}

    ngOnInit() {
        const selectedGroups = this.initialSearch.GroupIDs ?? [];
        const groups = this.formBuilder.array(this.Groups.map(group => selectedGroups.includes(group.GroupID)));

        this.form = this.formBuilder.group({
            Name: [this.initialSearch.Name, []],
            Status: [this.initialSearch.Status, []],
            ApproverUserId: [this.initialSearch.ApproverUserId, []], 
            Act48Status: [this.initialSearch.Act48Status, []],
            Groups: groups
        });

        this.setSelectedGroupCount();
    }

    clear() {
        this.form.get('Name').setValue('');
        this.form.get('Status').setValue(this.Statuses[0].value);
        this.form.get('ApproverUserId').setValue(null);
        this.form.get('Act48Status').setValue(null);

        // Clears groups and will also update form values and validity
        this.clearGroups();
    }

    onClearGroupsClicked($event: Event) {
        this.clearGroups();
        $event.stopPropagation();
    }

    private clearGroups() {
        (<UntypedFormArray>this.form.get('Groups')).controls.forEach(g => g.setValue(false));
        this.form.updateValueAndValidity();

        this.setSelectedGroupCount();
    }

    setSelectedGroupCount() {
        this.selectedGroupsCount = this.countSelectedGroups();
    }

    private countSelectedGroups() {
        return (<UntypedFormArray>this.form.get('Groups')).controls
            .reduce((count: number, g: AbstractControl) => count + (g.value ? 1 : 0), 0);
    }

    private toAdvancedRosterSearch(rawFormValue: any) {
        const advancedRosterSearch = new AdvancedRosterSearch();
        advancedRosterSearch.Name = rawFormValue.Name;
        advancedRosterSearch.Status = rawFormValue.Status;
        advancedRosterSearch.ApproverUserId = rawFormValue.ApproverUserId;
        advancedRosterSearch.Act48Status = rawFormValue.Act48Status;
        advancedRosterSearch.GroupIDs = rawFormValue.Groups
            .reduce((groupIds: string[], isSelected: boolean, index: number) => {
                if (isSelected) groupIds.push(this.Groups[index].GroupID);
                return groupIds;
            }, []);
        
        return advancedRosterSearch;
    }

    onSubmit({ value, valid } : { value: any, valid: boolean }) {
        if (valid) {
            const advancedRosterSearch = this.toAdvancedRosterSearch(value);
            this.activeModal.close(advancedRosterSearch);
        }
    }

}